export default {
  async request(method, type, body, contentType) {
    let response = await this.getQuery(method, type, body, contentType);

    const isUnauthorized =
      response &&
      (
        response.statusCode === 401 ||
        (response.serviceAnswer &&
        typeof response.serviceAnswer.error === "string" &&
        response.serviceAnswer.error.includes("JWT"))
      );

    if (isUnauthorized && response.serviceAnswer.message === 'Expired JWT Token') {
      const refreshResult = await this.refreshTokens();

      if (refreshResult) {
        return this.request(method, type, body, contentType)
      }
    }

    if (isUnauthorized && window.location.pathname !== '/authentication') {
      // Чистим всё, что связано с авторизацией
      try {
        sessionStorage.removeItem('auth');   // на всякий случай, если было
        localStorage.removeItem('auth');
      } catch (e) {
        console.error('Ошибка очистки хранилища:', e);
      }

      let redirect = null;

      // fullPath из vue-router
      if (this.$router && this.$router.currentRoute && this.$router.currentRoute.fullPath) {
        redirect = this.$router.currentRoute.fullPath;
      } else {
        // текущий URL
        redirect = window.location.pathname + window.location.search + window.location.hash;
      }

      localStorage.setItem('after_login_redirect', redirect);

      // Чистим токен-cookie
      document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;';

      // Отправляем на логин
      if (this.$router) {
        this.$router.replace('/authentication');
      } else {
        window.location.href = '/authentication';
      }
      return;
    }

    return response;
  },

  async getQuery(url, method = "GET", body = null, contentType = "application/json") {
    const token = this.getTokenFromCookie();

    const headers = {
      "Authorization": `Bearer ${token}`
    };

    let fetchOptions = {
      method,
      headers,
      redirect: "follow"
    };

    // POST/PUT с обычным JSON
    if ((method === "POST" || method === "PUT") && contentType !== "multipart/form-data") {
      headers["Content-Type"] = "application/json";
      fetchOptions.body = JSON.stringify(body);
    }

    // multipart/form-data без Content-Type
    if ((method === "POST" || method === "PUT") && contentType === "multipart/form-data") {
      fetchOptions.body = body; // FormData
    }

    try {
      const response = await fetch(process.env.VUE_APP_BACKEND_URL + url, fetchOptions);

      // Обработка ошибок
      if (!response.ok) {
        const serviceAnswer = await this.safeJson(response);
        return {
          statusCode: response.status,
          message: `Ошибка: ${response.status} на ${url}`,
          serviceAnswer
        };
      }

      // Обновляем токен при каждом успешном запросе
      this.refreshCookieToken();

      return await this.safeJson(response);

    } catch (e) {
      console.error("Ошибка запроса:", e);
      return {
        statusCode: 0,
        message: "Ошибка сети или соединения",
        error: e
      };
    }
  },

  async refreshTokens() {
    const response = await this.getQuery(
      '/token/refresh',
      'POST',
      {
        refresh_token: this.getRefreshTokenFromCookie(),
      }
    );

    if (response.statusCode === 401) {
      return false;
    }

    let new_minut = new Date();
    new_minut.setMinutes(new_minut.getMinutes() + 30);

    document.cookie = `token=${response.token};expires=${new_minut.toUTCString()}`
    document.cookie = `refresh_token=${response.refresh_token};expires=${new_minut.toUTCString()}`

    return true;

  },

  getTokenFromCookie() {
    return this.getParamFromCookie('token');
  },

  getRefreshTokenFromCookie() {
    return this.getParamFromCookie('refresh_token');
  },

  getParamFromCookie(paramKey) {
    const cookies = document.cookie.split("; ");

    for (const pair of cookies) {
      const [key, value] = pair.split("=");
      if (key === paramKey) return value || "";
    }
    return "";
  },

  refreshCookieToken() {
    const token = this.getTokenFromCookie();
    const refreshToken = this.getRefreshTokenFromCookie();

    if (!token || !refreshToken) return;

    const expires = new Date(Date.now() + 30 * 60 * 1000).toUTCString();
    document.cookie = `token=${token};expires=${expires};path=/;`;
    document.cookie = `refresh_token=${refreshToken};expires=${expires};path=/;`;
  },

  async safeJson(response) {
    try {
      return await response.json();
    } catch {
      return null;
    }
  }

}
